"use strict";
var FK_TYPES = {
    MEMBER_IDENTITY: 'member_identity',
    COMPANY_ENTITY_USER: 'company_entity_user'
};
module.exports = {
    FK_TYPES: FK_TYPES
};
